import React, { useRef, useState } from 'react';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form';
import { useFormDataContext } from '../../../lib/contexts';
import CustomBackButton from '../../CustomComponents/CustomBackButton';
import { useScrollToTop } from '../../../lib/hooks';

/** Slider values are in thousands (e.g. 500 => $500K). >= 1000 => millions (e.g. 1150 => 1.15M). */
function formatKAsKOrM(k) {
  if (k < 1000) {
    return `${k}K`;
  }
  const m = k / 1000;
  return `${Number(m.toFixed(2))}M`;
}

const SLIDER_MAX_K = 1500;

function FormStep6() {
  const { trigger, handleSubmit, formState } = useFormContext();
  const { updateFormData, formData, updateStep } = useFormDataContext();
  const { errors } = formState;
  const propertyvalue_highRef = useRef();
  const propValue = Math.floor(formData.propertyvalue / 1000);
  const [sliderValue, setSliderValue] = useState((propValue-50));
  const [maxSliderValue, setMaxSliderValue] = useState(propValue);

  const handleSliderChange = (event, newValue) => {
    setSliderValue(newValue);
    setMaxSliderValue(newValue + 50);
  };
  const handleClickContinue = handleSubmit(async (_data) => {
    updateFormData({
      propertyvalue: sliderValue === 50 ? '75000' : `${maxSliderValue}000`,
    });
    const isValid = await trigger(['propertyvalue']);

    if (!isValid) {
      const [firstErrorKey] = Object.keys(errors);
      const errorRefs = {
        propertyvalue: propertyvalue_highRef,
      };

      errorRefs[firstErrorKey]?.current?.focus();
    } else {
      updateStep(formData.step + 1);
    }
  });

  useScrollToTop();
  
  return (
    <div id="question6" style={{ margin: '50px auto 0' }}>
      <Typography id="home_value" gutterBottom>
        Estimate House Value
      </Typography>
      <Slider
        value={sliderValue}
        ref={propertyvalue_highRef}
        onChange={handleSliderChange}
        valueLabelDisplay="auto"
        valueLabelFormat={(v) =>
          v === SLIDER_MAX_K ? `$${formatKAsKOrM(SLIDER_MAX_K)}+` : `$${formatKAsKOrM(v)}`
        }
        aria-labelledby="estimated_home_value"
        min={50}
        max={SLIDER_MAX_K}
        step={50}
      />
      {
        sliderValue === 50 ?
        <Typography>Under $100K</Typography> :
        sliderValue === SLIDER_MAX_K ?
        <Typography>{`$${formatKAsKOrM(SLIDER_MAX_K)}+`}</Typography> :
        <Typography>{`$${formatKAsKOrM(sliderValue)} to $${formatKAsKOrM(maxSliderValue)}`}</Typography>
      }
      <input
        onClick={handleClickContinue}
        className="form-step__btn"
        type="button"
        value="Next"
      />
       <CustomBackButton/>
    </div>
  );
}

export default FormStep6;
